import { CheckCircleTwoTone } from '@ant-design/icons';
import React from 'react';

type Props = {
    twoToneColor?: string;
};

const CcxIconCheckCircleTwoTone = ({ twoToneColor }: Props) => {
    return (
        <CheckCircleTwoTone
            data-testid="CcxIconCheckCircleTwoTone"
            twoToneColor={twoToneColor}
        />
    );
};

export default CcxIconCheckCircleTwoTone;
